import { render, staticRenderFns } from "./vsNavbar.vue?vue&type=template&id=0bc31e9c&lang=html"
import script from "./vsNavbar.vue?vue&type=script&lang=js"
export * from "./vsNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports